import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { FORM_PAGES } from '../components/Form/types';
import { vars } from '../reactive';
import { setFormPage } from '../reactive/actions';
import { navigateRequiredOrdersForPaymentActions } from '../utils/handleOrderPaymentAction';
import { GetAllPets } from '../utils/queries';

export default function useUserProfile(navigatePets: boolean): ReturnType<
  typeof useLazyQuery<{
    getProfile: Queries.CollarAPI_AppUser;
  }>
> {
  const [getProfileQuery, { loading: getProfileLoading, data, ...rest }] = useLazyQuery<{
    getProfile: Queries.CollarAPI_AppUser;
  }>(GetAllPets, {
    fetchPolicy: 'no-cache'
  });
  const currentBranch = vars.currentBranch();
  const petTypes = currentBranch?.BranchTargeting?.pet_type;
  const isMoreThanOnePetType = petTypes?.length > 1;
  const newPet = vars.newPet();
  const [loading, setLoading] = useState(false);
  const account = useReactiveVar(vars.newAccount);
  const product = useReactiveVar(vars.selectedProduct);
  const forms = useReactiveVar(vars.selectedForms);
  const isFormFillView = useReactiveVar(vars.isFormFillView);

  useEffect(() => {
    (async () => {
      const userProfile = data;

      if (!userProfile?.getProfile?.id) {
        return;
      }

      setLoading(true);

      const isNavigating = await navigateRequiredOrdersForPaymentActions();

      if (!navigatePets || isNavigating) {
        return setLoading(false);
      }

      const allPets = [...userProfile.getProfile.Pets!, ...userProfile.getProfile.ChappedPets!];

      setLoading(false);

      if (isFormFillView && !forms?.[0]?.id) {
        setFormPage(FORM_PAGES.FORM_SELECT);
        return;
      }

      if (!isFormFillView && !product?.id) {
        setFormPage(FORM_PAGES.PRODUCTS);
        return;
      }

      if (allPets.length) {
        setFormPage(FORM_PAGES.BOOKING_SELECT_PETS);
        return;
      }

      if (account?.exists) {
        if (isMoreThanOnePetType) {
          setFormPage(FORM_PAGES.CREATE_PET_TYPE, 'fade-out');
        } else {
          vars.newPet({ ...newPet, type: petTypes[0] });
          setFormPage(FORM_PAGES.CREATE_PET_CREATE_PET);
        }
        return;
      }

      setFormPage(FORM_PAGES.CREATE_ACCOUNT_CREATED);
    })();
  }, [data]);

  return [getProfileQuery, { loading: getProfileLoading || loading, data, ...rest }];
}
